<!-- z-index 101: must beat layout__spotlight (z-index 100 in app.component.scss)
     so the collapsed nav's open-button remains clickable, but stay well below
     Radiance modal overlays (z-index 1000). Do not lower to 100 or below. -->
<rad-local-navigation 
#localNav
class="rad-theme--light" 
style="z-index: 101;"
[appShadowStyle]="localNavStyles"
(panelHidden)="updateExpandedState()"
(panelVisible)="updateExpandedState()">
  <ng-container *ngFor="let item of navItems">
    <rad-local-navigation-group
      #navGroup
      *ngIf="item.children; else simpleItem"
      [attr.group-label]="item.title"
      [attr.active]="isGroupActive(item) ? true : null"
      [appShadowStyle]="groupLabelStyles">
      <rad-local-navigation-item
        *ngFor="let child of item.children"
        [attr.item-label]="child.title"
        [attr.href]="child.url"
        [attr.active]="isActive(child) ? true : null"
        prevent-default="true"
        (itemClicked)="onItemClicked($event, child)"
      ></rad-local-navigation-item>
    </rad-local-navigation-group>
    <ng-template #simpleItem>
      <rad-local-navigation-item
        [attr.item-label]="item.title"
        [attr.href]="item.url"
        [attr.active]="isActive(item) ? true : null"
        prevent-default="true"
        (itemClicked)="onItemClicked($event, item)"
      ></rad-local-navigation-item>
    </ng-template>
  </ng-container>
  
  <!-- Settings link in footer slot (has built-in separator) -->
  <rad-local-navigation-item
    slot="footer"
    item-label="Settings"
    href="/settings"
    [attr.active]="isSettingsActive() ? true : null"
    prevent-default="true"
    (itemClicked)="onSettingsClicked($event)"
  ></rad-local-navigation-item>

  <!-- Resources link in footer slot -->
  <rad-local-navigation-item
    slot="footer"
    item-label="Resources"
    href="/resources"
    [attr.active]="isResourcesActive() ? true : null"
    prevent-default="true"
    (itemClicked)="onResourcesClicked($event)"
  ></rad-local-navigation-item>

  <!-- Trash link in footer slot -->
  <rad-local-navigation-item
    slot="footer"
    item-label="Trash"
    href="/settings/trash"
    [attr.active]="isTrashActive() ? true : null"
    prevent-default="true"
    (itemClicked)="onTrashClicked($event)"
    [appShadowStyle]="trashBadgeStyles"
    [appShadowDom]="trashBadgeConfig"
  ></rad-local-navigation-item>
</rad-local-navigation>
